import { Vuex, DmStores } from "division-marker";

import WtStore from "./shared/WtStore";
// Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    wt: WtStore,
    ...DmStores
  }
});
